
import { defineComponent, computed } from 'vue';
import { useRoute } from 'vue-router';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import { CONTACT_STATUS } from '@/types/enums';
import { useSpacesStore } from '@/modules/spaces/store/spacesStore';
import { useProfileStore } from '../store/profileStore';
import { useMainStore } from '@/store/mainStore';
import DriveAddMenuPopUp from '@/modules/drive/components/UI/DriveAddMenuPopUp.vue';

export default defineComponent({
  components: {
    DriveAddMenuPopUp,
    AppBottomPopUp,
    BottomPopUpItem,
  },
  props: {
    positionData: { type: Object },
  },
  emits: ['hidePopUp'],
  setup(props, { emit }) {
    const spacesStore = useSpacesStore();
    const profileStore = useProfileStore();
    const route = useRoute();
    const mainStore = useMainStore();

    const contactId = computed(() => route.params.id as string);
    const status = computed(() => profileStore.foreignProfile.status);

    function requestContact() {
      spacesStore.requestContact(contactId.value).then(() => {
        profileStore.foreignProfile.status = CONTACT_STATUS.REQUEST_SENT;
      });
      emit('hidePopUp');
    }

    function deleteContact() {
      spacesStore.deleteContact(contactId.value);
      profileStore.foreignProfile.status = CONTACT_STATUS.NO_CONTACT;
      emit('hidePopUp');
    }

    function acceptContact() {
      spacesStore.acceptContact(contactId.value);
      profileStore.foreignProfile.status = CONTACT_STATUS.CONTACT;
      emit('hidePopUp');
    }

    function rejectContact() {
      spacesStore.rejectContact(contactId.value);
      profileStore.foreignProfile.status = CONTACT_STATUS.NO_CONTACT;
      emit('hidePopUp');
    }

    function hidePopUp() {
      emit('hidePopUp');
    }
    return {
      requestContact,
      deleteContact,
      acceptContact,
      rejectContact,
      hidePopUp,
      status,
      CONTACT_STATUS,
      mainStore,
    };
  },
});
